import List from '@mui/material/List'
import { format } from 'date-fns'
import PropTypes from 'prop-types'
import React, { useMemo, Children } from 'react'

// eslint-disable-next-line import/no-cycle
import WorkOrderListItem from 'components/work-order/shared/WorkOrderListItem'
import { createDateFromString } from 'utils/date'
import { get } from 'utils/lodash'

const UpcomingWorkOrders = ({ serviceType, workOrders = [], linkWorkOrders = false, ...rest }) => {
  const sxProps = get(rest, 'sx', {})
  const hasWorkOrders = useMemo(() => workOrders.length > 0, [workOrders])

  return (
    <List dense>
      {hasWorkOrders &&
        Children.toArray(
          workOrders.map((workOrder, index) => {
            const serviceDate = get(workOrder, 'serviceDate')
            const woDate = createDateFromString(serviceDate)
            const formattedDate = format(woDate, 'MM/dd')

            return (
              <WorkOrderListItem
                key={workOrder.id || workOrder.workOrderId}
                divider={index !== workOrders.length - 1}
                formattedDate={formattedDate}
                linkToDetails={linkWorkOrders}
                primaryTypographyProps={{ variant: 'h5', fontWeight: 500 }}
                serviceType={serviceType}
                showSequence={false}
                sx={sxProps}
                workOrder={workOrder}
              />
            )
          })
        )}
    </List>
  )
}

UpcomingWorkOrders.propTypes = {
  serviceType: PropTypes.string.isRequired,
  workOrders: PropTypes.array,
  linkWorkOrders: PropTypes.bool,
}

export default UpcomingWorkOrders
